export default __webpack_public_path__ + "static/media/FIND_OPEN.4826d9bd.png";